import { Card } from 'antd';
import { useTranslation } from 'react-i18next';
import type { ReactNode } from 'react';
import { usePortalConfig } from '../config/PortalConfigProvider';

/**
 * The frame of the two UNAUTHENTICATED pages (login, password recovery): one centered
 * card on a light page, the product name above it, and — from W3 — the operator's own
 * footer beneath it.
 *
 * ⚠ WHAT IS NOT HERE, each because the thing behind it does not exist:
 *
 *   - a LANGUAGE SWITCH (`ui-…-personal-area` §1 shows three locales) — ST13 ships RU
 *     only, so the control would have one option;
 *   - a CAPTCHA (§1's ALTCHA widget) — no captcha exists anywhere in this system;
 *   - the LOGIN-RECOVERY link and the Telegram/MAX bot buttons — «operator-supplied» in
 *     §1, and `GET /pa/config` publishes neither, deliberately: its allow-list is seven
 *     strings and not a `personal_area.` prefix dump.
 *
 * ⚠ THE PRODUCT TITLE, THE WELCOME TEXT AND THE TERMS LINK ARRIVED IN W3, from
 * `GET /pa/config` — the listener's one public read (D258) and the reason W1b could build
 * none of them. Each renders only when the operator has set it, and an unset one produces
 * NO ELEMENT: a fallback company name would be somebody else's operator printed on this
 * one's login screen.
 */
export function EntryLayout({ children }: { children: ReactNode }) {
  const { t } = useTranslation();
  const config = usePortalConfig();
  return (
    <div className="pa-entry">
      <div className="pa-entry-card">
        <h1 className="pa-brand">{config.product_title || t('brand')}</h1>
        <Card>{children}</Card>
        {config.company_info || config.copyright_text ? (
          <div className="pa-entry-footer">
            {config.company_info ? <span>{config.company_info}</span> : null}
            {config.copyright_text ? <span>{config.copyright_text}</span> : null}
          </div>
        ) : null}
      </div>
    </div>
  );
}
